<template>
<div class="pt3-ns pt2 ph3 ph0-l flex flex-column w-100 textColor">
  <h1 class="bg-black-90 white fw2 f5 f4-ns ttu pv1 ph3 mr2-l mb0 mt3"><font-awesome-icon class="mr2" icon="trophy" size="sm"/>{{ $t("vinylContest.title") }}</h1>
  <div class="vinyl-contest">
    <div v-show="loading" class="flex justify-center h5 w-100 mv3">
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    </div>
    <div v-show="!loading" class="bg-primary flex flex-column justify-between mr2-l h-100">
      <div class="w-100 ph2 pv1 flex items-center justify-between"
          v-if="index < 4"
          v-for="(artist, index) in vinylContest"
          :track-by="artist.id"
          :key="artist.id">
        <vinyl-contest-podium class="mr2-l" :artist="artist" :index="index" :inHome="true"/>
      </div>
      <router-link :to="{ name:'charts'}" class="no-underline textColor pa2 db tr f6">
        <font-awesome-icon class="white" icon="external-link-alt"/>
        {{ $t("vinylContest.link") }}
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import VinylContestPodium from '@/components/charts/VinylContestPodium.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: 'vinyl-contest-home',
  components: {
    FontAwesomeIcon,
    VinylContestPodium,
    ClipLoader
  },
  data () {
    return {
      color: '#808080',
      size: '30px'
    }
  },
  computed: {
    ...mapGetters('artist', [
      'vinylContest',
      'vinylContestInfo',
      'error'
    ]),
    loading () {
      return this.$loading.isLoading('artist getVinylContest')
    }
  },
  created () {
    this.getVinylContest().catch((e) => {
      this.$toasted.show(this.error.message, {type: 'error'})
    })
  },
  methods: {
    ...mapActions('artist', [
      'getVinylContest'
    ])
  }
}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .vinyl-contest {
    height: 375px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/VinylContestHome.vue